import { ReactComponent as ScanPassportIllustration } from "assets/images/smart-gate-banner-illustration.svg";
import { Box, Icon, Text } from "components";
import useTrackPageAnalytics from "hooks/useTrackPageAnalytics";
import useWindowDimensions from "hooks/windowDimensions";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setSmartGateBannerVisible } from "redux/slices/flightsList.slice";
import { getTranslationsStyle } from "utils/arabisation.util";

const SmartGateBanner = () => {
  const { sendAnalytics } = useTrackPageAnalytics();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { width } = useWindowDimensions();

  return (
    <Box
      mH="m"
      pT="base"
      pB="base"
      pH="s"
      borderRadius="base"
      style={{ backgroundColor: "#5E64FF" }}
      onClick={() => {
        sendAnalytics({
          key: "smart-gate-click",
          type: "event",
          name: "Clicked on Smart Gate Banner",
        });
        navigate("/scan-passport");
      }}
    >
      <Box d="flex" justifyContent="space-between">
        <Text
          fontSize={width < 380 ? "base" : "m"}
          color="textQuaternary"
          fontWeight="semibold"
          style={getTranslationsStyle(i18n)}
          mB="s"
        >
          {t("smart_gate.banner_title")}
        </Text>
        <Icon
          size="l"
          color="backgroundQuaternary"
          name="Close"
          onClick={(event) => {
            event.stopPropagation();
            dispatch(setSmartGateBannerVisible(false));
          }}
        ></Icon>
      </Box>
      <Box d="flex">
        <Box flex="1.6">
          <Text color="textQuaternary" fontSize="m">
            {t("smart_gate.banner_description")}
          </Text>
        </Box>
        <Box
          flex="1"
          d="flex"
          justifyContent="center"
          alignItems="center"
          mR="_base"
          mL="_base"
        >
          <ScanPassportIllustration height={70} width={157} />
        </Box>
      </Box>
    </Box>
  );
};

export const SMART_GATE_BANNER_HEIGHT_SMALL = 165;
export const SMART_GATE_BANNER_HEIGHT_LARGE = 148;

export default SmartGateBanner;
